"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QnAListTable = void 0;
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const common_1 = require("../../../../common");
const option_1 = require("../../../../common/option");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const qna_1 = require("../../../../server/qna");
const popup_1 = require("../../../base/popup");
const action_1 = require("../../../menu/action");
const constant_1 = require("../constant");
const DSTS004_Detail_1 = require("../DSTS004_Detail");
const functions_1 = require("./functions");
const QnAItem_1 = require("./QnAItem");
const QnAListInfo_1 = require("./QnAListInfo");
const QnAStatistic_1 = require("./QnAStatistic");
const QnAStyled_1 = require("./QnAStyled");
const account_1 = require("../../../base/account");
exports.QnAListTable = react_1.default.memo(({ filterItems, isTeacher, isRetry = false, isHome = false, id = undefined, isPopUp = false, isHistory = false, hideDetail, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const historyStore = (0, GlobalStateProvider_1.useHistoryStore)();
    const user_id = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    // 로드 여부
    const [initLoad, setInitLoad] = (0, react_1.useState)(true);
    // 테이블에 사용되는 정보
    const [page, setPage] = (0, react_1.useState)(0); // 페이지 번호
    const [testData, setTestData] = (0, react_1.useState)([]); // Q&A 리스트 데이터
    const [questionData, setQuestionData] = (0, react_1.useState)([]); // 질문 데이터
    const [totalCount, setTotalCount] = (0, react_1.useState)(0); // 전체 데이터 개수
    const [count, setCount] = (0, react_1.useState)(isHome ? 5 : 10); // 화면에 보일 데이터 수
    // 검색 조건
    const [category, setCategory] = react_1.default.useState('');
    const [answerState, setAnswerState] = react_1.default.useState('');
    const [startDate, setStartDate] = (0, react_1.useState)('');
    const [endDate, setEndDate] = (0, react_1.useState)('');
    const [waiting, setWaiting] = (0, react_1.useState)(true);
    const [openCount, setOpenCount] = (0, react_1.useState)(0); // 답변 대기 수
    const [closedCount, setClosedCount] = (0, react_1.useState)(0); // 답변 완료 수
    // 필독 리스트
    const [searchOption, setSearchOption] = (0, react_1.useState)({});
    // detail ID
    const [selectedId, setSelectedId] = (0, react_1.useState)();
    // (교사만 해당) 검색 조건에 답변자로 포함 되어있는 경우에만 isAnswer = true
    const { isAnswer, isContent } = (0, react_1.useMemo)(() => {
        return {
            isAnswer: isTeacher && searchOption?.hasOwnProperty('answerer_author'),
            isContent: searchOption?.hasOwnProperty('answecontentrer_author'),
        };
    }, [isTeacher, searchOption]);
    const { data, refetch } = (0, qna_1.useQnaList)({
        ...(isHistory ? { root_id: id } : {}),
        offset: page === 0 ? 0 : page * count,
        limit: count,
        created_before: endDate && (0, moment_1.default)(endDate).isValid()
            ? (0, moment_1.default)(endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
            : undefined,
        created_after: startDate && (0, moment_1.default)(startDate).isValid()
            ? (0, moment_1.default)(startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
            : undefined,
        orderby: isHistory
            ? ['creation_time DESC']
            : ['importance DESC', 'creation_time DESC'],
        status: isHistory
            ? hideDetail
                ? [constant_1.QNA_STATUS.CLOSED]
                : [constant_1.QNA_STATUS.CLOSED, constant_1.QNA_STATUS.OPEN]
            : isTeacher
                ? isHome || waiting
                    ? [constant_1.QNA_STATUS.OPEN]
                    : undefined
                : [constant_1.QNA_STATUS.CLOSED, constant_1.QNA_STATUS.OPEN],
        ...(!isTeacher && (isHome || waiting ? { author_id: user_id } : {})),
        ...(isContent ? { group_by_round: true } : { with_respondent: true }),
        keyword: searchOption['keyword'],
        ...(category === '' || category === 'select' ? {} : { category }),
        ...(answerState === '' || answerState === 'select' ? {} : { status: answerState }),
        type: isAnswer ? constant_1.QNA_TYPE.ANSWER : constant_1.QNA_TYPE.QUESTION,
    }, 'qnaList');
    const refetchList = (0, lodash_1.throttle)(refetch, 1000, { leading: true, trailing: false });
    // 테이블에 사용될 데이터 - headTitleList : head key, tableReadDataKeys : 아이템 key
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => (0, functions_1.getQnAListOption)(isHome, isRetry, isTeacher, isMobile), [isHome, isRetry, isTeacher, isMobile]);
    (0, react_1.useEffect)(() => {
        const initializeState = async () => {
            const previousPage = historyStore.getRecentPageHistory('qnaListPage');
            const searchOptions = previousPage?.searchOption;
            if (searchOptions) {
                for (const key in searchOptions) {
                    switch (key) {
                        case 'searchOption':
                            setSearchOption(searchOptions[key]);
                            break;
                        case 'endDate':
                            setEndDate(searchOptions[key]);
                            break;
                        case 'startDate':
                            setStartDate(searchOptions[key]);
                            break;
                        case 'answerState':
                            setAnswerState(searchOptions[key]);
                            break;
                        case 'category':
                            setCategory(searchOptions[key]);
                            break;
                        case 'waiting':
                            setWaiting(searchOptions[key]);
                            break;
                    }
                }
            }
            setPage(previousPage?.prePage || 0);
            setInitLoad(true);
        };
        initializeState();
        return () => {
            setInitLoad(false);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('REFETCH_QNA_LIST', refetchList);
        return () => {
            APP.eventManager.unsubscribe('REFETCH_QNA_LIST', refetchList);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        setCount(isHome ? 5 : 10);
    }, [isHome]);
    (0, react_1.useEffect)(() => {
        if (!initLoad)
            return;
        if (isHistory && !id)
            return;
        refetchList();
    }, [
        initLoad,
        searchOption,
        isRetry,
        waiting,
        page,
        category,
        answerState,
        startDate,
        endDate,
        id,
        isHistory,
    ]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, items, found_count, open_count, closed_count } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / count) - 1);
                setPage(maxPage);
                return;
            }
            if (found_count > 0) {
                /**
                 * 화면 표시 번호를 목록 위치로 다시 매긴다.
                 *
                 * 서버 고유번호(item.index)는 등록 시점에 매겨져 저장되는 값이라 중간 글을 지우면
                 * 결번이 생긴다(4,3,2,1 에서 3번 삭제 시 4,2,1). DB 원본은 그대로 두고 화면 번호만 바꾼다.
                 *
                 * Q&A 는 공지와 달리 필독 글이 목록에 중복으로 내려오지 않는다 — orderby 의
                 * importance DESC 로 시퀀스 맨 앞에 모일 뿐이다. 따라서 앞쪽 번호는 필독 행이
                 * 가져가고(그 행은 번호 대신 '필독' 표시), 일반 글은 (전체 - 필독수) → 1 로
                 * 끊김 없이 이어진다. 별도의 필독 개수 보정이 필요 없다.
                 *
                 * 클라 필터(filterItems·root_id)를 적용하기 전에 매긴다 — 번호는 서버가 준
                 * 정렬·페이지 위치를 기준으로 해야 페이지를 넘어가도 이어지기 때문이다.
                 */
                const numberedItems = items.map((item, idx) => ({
                    ...item,
                    displayNumber: total_count - (page * count + idx),
                }));
                const testItem = filterItems
                    ? numberedItems.filter(item => !filterItems.includes(item.id))
                    : numberedItems;
                setTestData(id ? testItem.filter(item => item.root_id === id) : testItem);
                setTotalCount(isHome ? Math.min(total_count, 5) : total_count);
                setOpenCount(open_count);
                setClosedCount(closed_count);
                return;
            }
        }
        setTestData([]);
        setTotalCount(0);
        setOpenCount(0);
        setClosedCount(0);
    }, [data, filterItems]);
    const handlerMoreData = (page) => setPage(page);
    const downloadFilter = (0, react_1.useMemo)(() => {
        return {
            ...(isHistory ? { root_id: id } : {}),
            created_before: endDate && (0, moment_1.default)(endDate).isValid()
                ? (0, moment_1.default)(endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
                : undefined,
            created_after: startDate && (0, moment_1.default)(startDate).isValid()
                ? (0, moment_1.default)(startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ')
                : undefined,
            orderby: isHistory
                ? ['creation_time DESC']
                : ['importance DESC', 'creation_time DESC'],
            status: isTeacher
                ? isHome || waiting
                    ? [constant_1.QNA_STATUS.OPEN]
                    : undefined
                : [constant_1.QNA_STATUS.CLOSED, constant_1.QNA_STATUS.OPEN],
            ...(!isTeacher && (isHome || waiting ? { author_id: user_id } : {})),
            ...(isContent ? { group_by_round: true } : { with_respondent: true }),
            keyword: searchOption['keyword'],
            ...(category === '' || category === 'select' ? {} : { category }),
            ...(answerState === '' || answerState === 'select' ? {} : { status: answerState }),
            type: isAnswer ? constant_1.QNA_TYPE.ANSWER : constant_1.QNA_TYPE.QUESTION,
        };
    }, [
        isHistory,
        id,
        page,
        count,
        endDate,
        startDate,
        waiting,
        searchOption,
        isAnswer,
        answerState,
        category,
        isContent,
        isTeacher,
        isHome,
        user_id,
    ]);
    /**
     *
     */
    const renderQnAStatistics = (0, react_1.useMemo)(() => (react_1.default.createElement(QnAStatistic_1.QnAStatistic, { totalCount: totalCount, openCount: openCount, closedCount: closedCount })), [totalCount, openCount, closedCount]);
    /**
     *
     */
    const renderQnAListInfo = (0, react_1.useMemo)(() => (react_1.default.createElement(QnAListInfo_1.QnAListInfo, { answerState: answerState, category: category, startDate: startDate, endDate: endDate, searchOption: searchOption, waiting: waiting, setStartDate: setStartDate, setEndDate: setEndDate, setAnswerState: setAnswerState, setCategory: setCategory, setSearchOption: setSearchOption, setWaiting: setWaiting, downloadFilter: downloadFilter })), [downloadFilter, waiting, answerState, category, startDate, endDate, searchOption]);
    /**
     * (onClick) 재질문 -> 자세히 보기 상세 페이지로 이동
     */
    const goToDetailPage = (root_id, index) => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DSTS004_Detail_1.DSTS004_Detail,
            componentProps: {
                root_id,
                depths: index,
                isPopup: true,
                isHistory: true,
            },
            width: 1040,
            height: 'unset',
            title: t('supportRoom.showQuestion'),
        });
    };
    /**
     * (onClick) 상세 페이지로 이동
     *
     * Q&A 가 열려있는 경우 + 강사, 조교인 경우
     * 	-> 답변하기 페이지로 이동
     * 그 외
     *  -> 상세 페이지로 이동
     */
    const handlerSelectItem = (item) => {
        if (isHistory) {
            setSelectedId(selectedId === item.id ? undefined : item.id);
            return;
        }
        // 새로운 페이지로 이동할 때 현재 상태를 기록
        const historyItem = {
            preItems: {},
            props: {
                isTeacher,
                isRetry,
                isHome,
                id,
                isPopUp,
                isHistory,
                hideDetail,
            },
            prePage: page,
            searchOption: {
                searchOption,
                endDate,
                startDate,
                answerState,
                category,
                waiting,
            },
            pageName: 'qnaListPage',
        };
        historyStore.pushHistory(historyItem);
        if (constant_1.QNA_STATUS.OPEN === item.status && isTeacher) {
            dispatch((0, action_1.updateMenu)('learningSupportRoom', { menu: 'qna', detail: 'answer' }, item.root_id, {
                depths: Math.max(item.number - 1, 0),
                answer_number: item.number,
                isModify: false,
                isTeacher,
                isRequestion: isRetry,
            }));
        }
        else {
            dispatch((0, action_1.updateMenu)('learningSupportRoom', { menu: 'qna', detail: 'detail' }, item.root_id, {
                title: item.title,
                isHistory,
                depths: Math.max(item.number - 1, 0),
                isHidePaging: true,
                isPopup: isPopUp,
                isContent: isContent || isAnswer,
            }));
        }
    };
    const renderMoreItem = (item, styles) => {
        return (react_1.default.createElement("div", { className: "more_item" },
            react_1.default.createElement(DSTS004_Detail_1.DSTS004_Detail, { root_id: item.root_id, depths: item.number - 1, isHidePaging: true, isContent: isContent || isAnswer, isHistory: isHistory, isPopup: false })));
    };
    /**
     * 9
     */
    const renderItem = (item, styles, index) => {
        // 필요한 데이터를 계산
        const listData = (isAnswer && searchOption['author']) || (isContent && item.type === 'answer')
            ? questionData.filter(data => item.number - data.number === 1 && item.root_id === data.root_id)
            : null;
        const dataToUse = listData && listData.length > 0 ? listData[0] : item;
        const isSelected = item.id === selectedId;
        if (!dataToUse)
            return null;
        return (react_1.default.createElement(react_1.default.Fragment, null, tableReadDataKeys.map(headItem => {
            const number = item.index ?? 0;
            // 'No' 칼럼에 쓸 표시 번호. dataToUse 가 다른 행(질문 원본)일 수 있으므로
            // 이 행(item)의 값을 별도 prop 으로 넘긴다. 미계산 시 기존 동작인 고유번호로 폴백.
            const displayNumber = item.displayNumber ?? item.index ?? 0;
            return (react_1.default.createElement("div", { key: `${headItem.title}-${item.id}`, className: `body-item ${isSelected && (isMobile ? headItem.title === 'content' : true)
                    ? 'bold-pur'
                    : ''} ${headItem.title}`, style: {
                    flex: headItem.space,
                    maxWidth: headItem?.maxWidth ? headItem.maxWidth : 'auto',
                    ...styles?.bodyItem,
                } },
                react_1.default.createElement(QnAItem_1.QnAItem, { isHome: isHome, isAnswer: isAnswer, isContent: isContent, isTeacher: isTeacher, isTablet: isTablet, isMobile: isMobile, isSelected: isSelected, isHistory: isHistory, headItem: headItem, item: dataToUse, number: number, displayNumber: displayNumber, handlerShowDetail: goToDetailPage })));
        })));
    };
    /**
     * (Empty) 데이터가 없을 경우
     */
    const renderEmpty = (0, react_1.useMemo)(() => react_1.default.createElement(option_1.EmptyTable, { title: "supportRoom.questionEmpty" }), []);
    return (react_1.default.createElement(QnAStyled_1.QnAListTableStyled, { className: "qna-list-table", "$isHistory": isHistory, "$isHome": isHome, "$isRetry": isRetry, "$isTablet": isTablet, "$isPopUp": isPopUp, "$isMobile": isMobile, "$isTeacher": isTeacher },
        !isHistory && !isRetry && !isHome && !id && renderQnAListInfo,
        react_1.default.createElement("div", { className: `qna-section${isHistory ? ' history' : ''}${isHome ? ' home' : ''}` },
            isTeacher && !isRetry && !isHome && !id && renderQnAStatistics,
            react_1.default.createElement(common_1.Table, { className: isRetry ? 'qna-list-002' : 'qna-list-001', showCheckBox: false, isInfinite: isRetry || isHome ? true : false, selectedId: selectedId, padding: false, page: page, showCount: count, data: testData, totalCount: totalCount, headTitleList: headTitleList, renderItem: renderItem, renderMoreItem: renderMoreItem, renderEmpty: totalCount <= 0 && renderEmpty, handlerSelectItem: hideDetail ? isMobile ? handlerSelectItem : undefined : handlerSelectItem, handlerMoreData: hideDetail ? undefined : handlerMoreData, forceShowheader: !isRetry && (isHistory || isMobile || headTitleList.length <= 0)
                    ? false
                    : true }))));
});
